<template>
  <div class="order-logistics clearfix">
    <div class="order-logistics-top clearfix" style="display: flex">
      <span
      >关联物流信息共 {{ page.totalResult }} 条 | 实际到货总数
        {{ amount.totalRealCounts }} 吨</span
      >
      <Button
          v-if="isHavePermission('ordersBuyer:deleteAllLogistics')"
          @click="deleteAll"
          style="margin-left: auto"
      >
        删除全部物流
      </Button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style table-style-spce"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="540"
          border="none"
          auto-resize
          :loading="loading"
          :data="logisticsListData"
          align="center"
          :footer-method="footerMethod1"
          @filter-change="filterChangeMethod"
      >
        <vxe-table-column type="seq" title="序号" width="100">
          <template slot-scope="{ row, $rowIndex }">
            <span>{{ $rowIndex + 1 }}</span>
            <Dropdown
                v-if="isHavePermission('logistics:removeLogistics')"
                trigger="click"
                style="margin-left: 20px"
                transfer
            >
              <icon
                  type="text"
                  custom="iconfont icon-gengduo"
                  size="12px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" @click="confirmEvent(row.id)"
                  >移除物流信息
                  </Button
                  >
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsNum" title="物流编号" width="140">
          <template slot-scope="{ row }">
            <span
                @click="showLogisticsDetail(row.id)"
                style="color: #2d8cf0; cursor: pointer"
            >{{ row.logisticsNum }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="logisticsCode"
            title="物流单号"
            width="140"
        ></vxe-table-column>
        <vxe-table-column field="isTop" title="状态" width="120" show-overflow>
          <template slot-scope="{ row }">
            <span
                :style="
                isHavePermission('logistics:isTop') ? 'margin-left: 25px;' : ''
              "
            >{{ row.isTop | logisticsIsTopStatusMap }}</span
            >
            <Dropdown
                v-if="isHavePermission('logistics:isTop')"
                trigger="click"
                style="margin-left: 10px; cursor: pointer"
                transfer
            >
              <span style="position: relative; margin-left: 20px">
                <Icon type="ios-arrow-down" style="margin-top: -3px"/>
              </span>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <!-- 物流状态 :  1->正常对应目前已审核 有轨迹且匹配（）、0->未知（对应目前待审核）、-1->数据异常（轨迹不匹配）、-2->离线（无轨迹） -->
                  <!-- -3 ->通信异常（平台无轨迹其他家有）、-4->AIS异常（有定位无轨迹）此状态只有船舶有 -->
                  <section
                      v-for="item in logisticsIsTopOptions"
                      v-bind:key="item.value"
                  >
                    <Button
                        class="button-gengduo"
                        v-if="row.isTop != item.value"
                        @click="setTop(row.id, item.value)"
                    >{{ item.label }}
                    </Button>
                  </section>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="goodsType"
            title="货物类型"
            width="140"
            :filters="filterGoodsType"
            :filter-multiple="false"
        ></vxe-table-column>
        <vxe-table-column
            field="goodsName"
            title="货品名称"
            width="140"
        ></vxe-table-column>
        <!--        <vxe-table-column field="goodsRule" title="规格" width="60"></vxe-table-column>-->
        <vxe-table-column
            field="goodsUnit"
            title="单位"
            width="100"
        ></vxe-table-column>
        <!--        <vxe-table-column field="counts" title="装货数量" width="80"></vxe-table-column>-->
        <!--        <vxe-table-column field="deviate" title="盈亏数量" width="100"></vxe-table-column>-->
        <vxe-table-column
            field="realCount"
            title="实际数量"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="140">
          <template slot-scope="{ row }">
            <div
                style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <span
                  v-if="row.logisticsType === 1"
                  :style="
                  row.carShipState === 3
                    ? 'color: #2D8CF0;cursor:pointer'
                    : 'cursor:pointer'
                "
                  @click="showCarDetail(row)"
              >{{ row.carShipNum }}</span
              >
              <span
                  v-if="row.logisticsType === 2"
                  :style="
                  row.carShipState === 3
                    ? 'color: #2D8CF0;cursor:pointer'
                    : 'cursor:pointer'
                "
                  @click="showShipDetail(row)"
              >{{ row.carShipNum }}</span
              >
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
            v-if="isHavePermission('logistics:getMap')"
            title="轨迹"
            width="50"
        >
          <template slot-scope="{ row }">
            <div
                style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                  v-if="row.trackUrl || row.logisticsType === 2"
                  style="width: 20px; height: 20px"
                  src="@/assets/images/common/icon-guiji.png"
                  @click="getMap(row)"
              />
              <img
                  v-else
                  style="width: 20px; height: 20px"
                  src="@/assets/images/common/icon-noguiji.png"
              />
            </div>
          </template>
        </vxe-table-column>
        <!--        <vxe-table-column field="voyage" title="航次号"></vxe-table-column>-->
        <!--        <vxe-table-column field="deliveryPlace" title="交货地点"></vxe-table-column>-->
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="200"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="目的地"
            width="200"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.endTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal
        v-model="detailVisible"
        title="查看物流详情"
        width="1300"
        height="650"
        @close="closeDetailModal"
        resize
        remember
    >
      <detail-modal ref="detailModal" @goUpdate="openUpdateView"></detail-modal>
    </vxe-modal>
    <vxe-modal
        v-model="updateVisible"
        title="编辑物流详情"
        width="1300"
        height="650"
        @close="closeUpdateModal"
        resize
        remember
    >
      <update-modal ref="updateModal" @afterSave="close"></update-modal>
    </vxe-modal>
    <vxe-modal
        v-model="createCarVisible"
        :title="createCarTitle"
        width="1400"
        height="860"
        @close="closeCarCreate"
        resize
        position="center"
    >
      <create-car-modal
          @afterSave="closeCarCreateModal"
          ref="modalCarCreate"
          @close="closeCar"
      ></create-car-modal>
    </vxe-modal>
    <vxe-modal
        v-model="createShipVisible"
        :title="createShipTitle"
        width="1400"
        height="900"
        @close="closeShipCreate"
        resize
        position="center"
        destroy-on-close
    >
      <create-ship-modal
          @afterSave="closeShipCreateModal"
          @close="createShipVisible = false"
          ref="modalShipCreate"
      ></create-ship-modal>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import $C from "@/consts/index";
  import DetailModal from "@/views/logistics/DetailModal";
  import UpdateModal from "@/views/logistics/UpdateModal";
  import {isEmpty} from "@/utils/util";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import moment from "moment";
  import CreateCarModal from "@/views/carShip/CreateCarModal";
  import CreateShipModal from "@/views/carShip/CreateShipModal";

  export default {
    props: {
      id: String,
      pageTab: String,
    },
    components: {DetailModal, UpdateModal, CreateCarModal, CreateShipModal},
    mixins: [getAuthOrization],
    data() {
      return {
        createCarVisible: false,
        createShipVisible: false,
        createCarTitle: "",
        createShipTitle: "",
        loading: false,
        logisticsListData: [],
        logisticsIsTopOptions: $C.LogisticsIsTopStatus.options,
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        amount: {
          totalCounts: 0,
          totalRealCounts: 0,
        },
        detailVisible: false,
        updateVisible: false,
        trackFlag: false,
        url: "",
        isCar: true,
        filterGoodsType: [],
        fliterName: null,
      };
    },
    watch: {
      // id(nv, ov) {
      //   if (nv !== ov && nv !== undefined) {
      //     this.getLogisticsListData();
      //   }
      // },
      pageTab() {
        this.pageTab === "tab2" ? this.init() : "";
      },
    },
    mounted() {
      this.getDicType()
    },
    // activated() {
    //   // this.getLogisticsListData();
    //   this.$bus.$on("orderDetailRenovate", (data) => {
    //     data === true ? this.getLogisticsListData() : "";
    //   });
    // },
    methods: {
      init() {
        this.page.currentPage = 1
        this.getLogisticsListData()
      },
      getDicType() {
        this.filterGoodsType = [];

        $api.other.getGoodsTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictText,
              };
              this.filterGoodsType.push(obj);
            });
            const goodsTypeColumn = this.$refs.xGrid.getColumnByField(
              "goodsType"
            );
            this.$refs.xGrid.setFilter(goodsTypeColumn, this.filterGoodsType);
          });
      },
      filterChangeMethod({values}) {
        this.page.currentPage = 1;
        if (values.length > 0) {
          this.fliterName = values[0];
        } else {
          this.fliterName = null;
        }
        this.getLogisticsListData()
      },
      showCarDetail(row) {
        if (row.carShipId) {
          this.createCarTitle = "查看车辆信息";
          this.createCarVisible = true;
          this.$refs.modalCarCreate.init();
          this.$refs.modalCarCreate.queryCarDetail(row.carShipId);
          this.$refs.modalCarCreate.setReadOnly();
        } else {
          this.$XModal.alert({
            message: "暂无车辆信息",
            status: "error",
          });
        }
      },
      showShipDetail(row) {
        if (row.carShipId) {
          this.createShipTitle = "查看船舶信息";
          this.createShipVisible = true;
          this.$nextTick(() => {
            this.$refs.modalShipCreate.queryShipDetailNew(row.carShipId);
            this.$refs.modalShipCreate.setReadOnly();
          });
        } else {
          this.$XModal.alert({
            message: "暂无船舶信息",
            status: "error",
          });
        }
      },
      closeCarCreateModal(type) {
        this.createCarVisible = false;
        if (type === "afterSave") {
          this.queryLogisticsList();
        }
      },
      closeCarCreate() {
        this.$refs.modalCarCreate.reset();
      },
      closeCar() {
        this.createCarVisible = false;
        this.$refs.modalCarCreate.clearV();
      },
      closeShipCreateModal() {
        this.createShipVisible = false;
        this.queryLogisticsList();
      },
      closeShipCreate() {
        this.$refs.modalShipCreate.reset();
      },
      deleteAll() {
        this.$XModal.confirm("确认删除全部订单关联物流信息").then((type) => {
          if (type === "confirm") {
            this.removeLogisticsByOrder();
          }
        });
      },
      async removeLogisticsByOrder() {
        let res = await $api.logistics.request("removeLogisticsByOrder", {
          orderId: this.id,
          orderType: 1,
        });
        if (res.status === 1) {
          this.$XModal.message({message: `删除成功！`});
          this.getLogisticsListData();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      getMap(row) {
        if (row.logisticsType === 1) {
          this.seeCarMap(row);
        } else {
          this.seeShipMap(row);
        }
      },
      seeCarMap(row) {
        let that = this;
        let url = '/carShip/fwCarFrame';
        this.fwCar = window.open(url);
        setTimeout(function () {
          that.fwCar.postMessage(JSON.stringify({carInfo: row, logistics: true}), '*');
        }, 2000);
      },
      seeShipMap(row) {
        let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
        if (mmsi == null || mmsi === '') {
          //暂无数据
          this.$Message.error('暂无数据');
          return
        }
        let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
        let deliveryDates = moment(row.endTime).format("YYYY-MM-DD")
        let obj = {
          startTime: beginTime + " 00:00:00",
          endTime: deliveryDates + " 00:00:00",
          mmsi: mmsi
        }
        let that = this;
        let url =  '/carShip/fwShipFrame';
        this.fwShip = window.open(url);
        this.$nextTick(function () {
          setTimeout(function () {
            that.fwShip.postMessage(JSON.stringify(obj), '*')
          }, 2000);
        });
      },
      // 船舶日期往前推N天
      dateAddDays(dataStr, dayCount) {
        let isdate = new Date(dataStr.replace(/-/g, "/"));
        isdate = new Date((isdate / 1000 - 86400 * dayCount) * 1000); //日期-N天
        let strMonth = isdate.getMonth() + 1;
        let strDate = isdate.getDate();
        let strYear = isdate.getFullYear();
        if (strMonth >= 1 && strMonth <= 9) {
          strMonth = "0" + strMonth;
        }
        if (strDate >= 1 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return strYear + "-" + strMonth + "-" + strDate;
      },
      async queryLogisticsList() {
        this.loading = true;
        let res = await $api.logistics.request("queryLogisticsListSelect", {
          orderBy: 6,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.totalCounts = res.data.countRtnVo.totalCounts;
          this.totalRealCounts = res.data.countRtnVo.totalRealCounts;
          this.tableData = res.data.rows;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async getLogisticsListData() {
        if (isEmpty(this.id)) return;
        this.loading = true;
        let res = await $api.logistics.request("queryLogisticsListSelect", {
          ordersBuyerId: this.id,
          orderBy: 6,
          page: this.page.currentPage,
          rows: this.page.pageSize,
          goodsType: this.fliterName
        });
        if (res.status === 1) {
          this.amount.totalCounts = res.data.countRtnVo.totalCounts;
          this.amount.totalRealCounts = res.data.countRtnVo.totalRealCounts;
          this.page.totalResult = res.data.total;
          this.logisticsListData = res.data.rows;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      openUpdateView(id) {
        if (!this.isHavePermission('logistics:queryLogisticsDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.updateVisible = true;
        this.$refs.updateModal.queryLogisticsDetail(id);
      },
      async setTop(id, isTop) {
        let res = await $api.logistics.request("updateTopState", {
          id: id,
          isTop: isTop,
        });
        if (res.status === 1) {
          this.$Message.success("操作成功");
          this.getLogisticsListData();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      close() {
        this.updateVisible = false;
        this.detailVisible = false;
        this.$refs.detailModal.close();
        this.getLogisticsListData();
      },
      closeDetailModal() {
        this.detailVisible = false;
        this.$refs.detailModal.close();
      },
      closeUpdateModal() {
        this.updateVisible = false;
        this.$refs.updateModal.close();
      },
      async confirmEvent(id) {
        this.$XModal
          .confirm(
            "移除后，此物流信息关联的订单将解除关联关系",
            "是否移除此物流信息？"
          )
          .then((type) => {
            // this.$XModal.message({ message: `点击了 ${type}` });
            if (type === "confirm") {
              this.removeLogistics(id);
            }
          });
      },
      async removeLogistics(id) {
        let res = await $api.logistics.request("updateLogisticsUnbind", {
          id: id,
        });
        if (res.status === 1) {
          this.$XModal.message({message: `移除成功！`});
          this.getLogisticsListData();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      showLogisticsDetail(id) {
        if (!this.isHavePermission('logistics:queryLogisticsDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.detailVisible = true;
        this.$refs.detailModal.queryLogisticsDetail(id);
      },
      handlePageChange({currentPage, pageSize}) {
        // 分页
        this.page.currentPage = currentPage;
        this.page.pageSize = pageSize;
        // this.paramsObj.goodsType = this.fliterName;
        this.getLogisticsListData();
      },
      footerMethod1({columns, data}) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return "单页合计";
            }
            if (["realCount", "counts"].includes(column.property)) {
              return this.$utils.sum(data, column.property);
            }
            return null;
          }),
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return "全部合计";
            }
            if (["counts"].includes(column.property)) {
              return this.amount.totalCounts;
            }

            if (["realCount"].includes(column.property)) {
              return this.amount.totalRealCounts;
            }
            return null;
          }),
        ];
      },
    },
  };
</script>

<style>
  .order-logistics-top {
    height: 40px;
    line-height: 40px;
  }

  .trackBoxOrder {
    width: 96%;
    height: 100vh;
    position: fixed;
    left: 68px;
    top: 110px;
    z-index: 999;
    background: #fff;
  }
</style>
